module.exports = __webpack_public_path__ + "img/page36.6ca6af61.gif";